<template>
  <section>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-2 has-text-grey-dark">Editar Usuario</h1>
          <h1 class="title has-text-grey">{{ user.displayName }}</h1>
          <h2 class="subtitle has-text-grey">{{ user.email }}</h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <section class="margin-top">
          <div class="field">
            <div class="columns is-multiline">
              <div class="column">
                <input
                  v-model="user.claims.admin"
                  class="is-checkradio"
                  id="ch"
                  type="checkbox"
                  name="ch"
                />
                <label for="ch">admin</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.contador"
                  class="is-checkradio"
                  id="ch1"
                  type="checkbox"
                  name="ch1"
                />
                <label for="ch1">contador</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.auxiliar"
                  class="is-checkradio"
                  id="ch2"
                  type="checkbox"
                  name="ch2"
                />
                <label for="ch2">auxiliar</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.gerente"
                  class="is-checkradio"
                  id="ch3"
                  type="checkbox"
                  name="ch3"
                />
                <label for="ch3">gerente</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.help"
                  class="is-checkradio"
                  id="ch4"
                  type="checkbox"
                  name="ch4"
                />
                <label for="ch4">help</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.vendedor"
                  class="is-checkradio"
                  id="ch5"
                  type="checkbox"
                  name="ch5"
                />
                <label for="ch5">vendedor</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.comision"
                  class="is-checkradio"
                  id="ch6"
                  type="checkbox"
                  name="ch6"
                />
                <label for="ch6">comision</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.developer"
                  class="is-checkradio"
                  id="ch7"
                  type="checkbox"
                  name="ch7"
                />
                <label for="ch7">Desarrollador</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.proyectos"
                  class="is-checkradio"
                  id="ch8"
                  type="checkbox"
                  name="ch8"
                />
                <label for="ch8">Proyectos</label>
              </div>
              <div class="column">
                <input
                  v-model="user.claims.task"
                  class="is-checkradio"
                  id="ch9"
                  type="checkbox"
                  name="ch9"
                />
                <label for="ch9">Task</label>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <button
                class="button is-primary is-large is-fullwidth"
                @click="editUser(null, 'editPermission')"
              >
                <i class="material-icons">security</i>&nbsp;Actualizar Permisos
              </button>
            </div>
          </div>
          <div class="field has-addons">
            <p class="control has-icons-left is-expanded">
              <span class="select is-large is-fullwidth">
                <select v-model="current">
                  <option
                    v-for="option in empresas"
                    v-bind:value="option"
                    v-bind:key="option._id"
                  >
                    {{ option.nombrec }} {{ option.nit }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="material-icons">location_city</i>
              </span>
            </p>
            <div class="control">
              <button
                @click="editUser(current, 'addCompany')"
                class="button is-primary is-large"
              >
                <i class="material-icons">playlist_add</i>&nbsp;Agregar
              </button>
            </div>
          </div>
          <h1 class="title">Empresas Asignadas</h1>
          <table class="table is-fullwidth table is-striped">
            <thead>
              <tr>
                <th></th>
                <th>Empresa</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in empresasUser" :key="item.$index">
                <td></td>
                <td>
                  <h5 class="title is-5">
                    {{ item.nombrec }}
                    <small>{{ item.nit }}</small>
                  </h5>
                  <h6 class="subtitle is-6">{{ item.nombre }}</h6>
                </td>
                <td>
                  <a
                    v-show="showDelete"
                    @click="editUser(item, 'deleteCompany')"
                    class="button is-danger"
                  >
                    <i class="material-icons">delete_forever</i>&nbsp;Eliminar
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </section>
    <section class="section">
      <div class="container"></div>
    </section>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      user: {
        currentCompany: "",
        claims: {},
        companys: {},
      },

      empresas: [],
      empresasUser: [],
      current: "",
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    showDelete() {
      if (this.empresasUser.length > 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    borrar() {
      this.nombre = "";
      this.valor = "";
    },
    async enviar() {
      try {
        this.user.extraFields.currentCompany = this.current._id;
        this.user.extraFields.companys = {};
        this.user.extraFields.companys[this.current._id] = {
          id: this.current._id,
        };
        await apiServices.post(`/users`, this.user);
        this.$store.dispatch("notify", {
          message: "Perfecto. Usuario Creado con éxito",
        });
      } catch (error) {
        console.log(error);
        this.$store.dispatch("notify", {
          message: "Ups, ocurrió un error. Inténtelo nuevamente.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
    async getUserandEmpresa(_this) {
      function getUser(id) {
        const result = apiServices.get(`/user/${id}`);
        return result;
      }
      function getEmpresas() {
        const result = apiServices.get(`/empresas`);
        return result;
      }
      try {
        const userEmpresas = await Promise.all([
          getUser(_this.$route.params.id),
          getEmpresas(),
        ]);
        _this.user = userEmpresas[0].data;
        const d = {
          _id: "",
          nombrec: "Agregar Empresa",
          nit: "",
        };
        _this.empresas = [].concat([d], userEmpresas[1].data);
        _this.current = d;
        const empresasUser = Object.keys(_this.user.companys);
        userEmpresas[1].data.forEach((k) => {
          empresasUser.forEach((k1) => {
            if (k._id === k1) {
              _this.empresasUser.push(k);
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async editUser(i, caso) {
      if (caso === "deleteCompany") {
        delete this.user.companys[i._id];
      }
      if (caso === "addCompany") {
        this.user.companys[i._id] = {
          id: i._id,
        };
      }
      this.empresasUser = [];
      const empresasUser = Object.keys(this.user.companys);
      this.empresas.forEach((k) => {
        empresasUser.forEach((k1) => {
          if (k._id === k1) {
            this.empresasUser.push(k);
          }
        });
      });
      try {
        await apiServices.put(
          `/user/update/${this.$route.params.id}`,
          this.user
        );
        this.$store.dispatch("notify", {
          message: `El usuario fue editado con éxito`,
          type: "is-link",
        });
      } catch (error) {
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo editar el usuario`,
          type: "is-danger",
        });
      }
    },
  },
  created() {
    this.getUserandEmpresa(this);
  },
};
</script>

<style lang="scss" scoped>
.is-checkradio[type="radio"]:checked + label::before,
.is-checkradio[type="radio"]:checked + label:before,
.is-checkradio[type="checkbox"]:checked + label::before,
.is-checkradio[type="checkbox"]:checked + label:before {
  border: 0.15rem solid #dbdbdb;
}
.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  border-width: 0.15rem;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/EditUser.vue